import { render } from "./ClaimsPage.vue?vue&type=template&id=31ab8b50"
import script from "./ClaimsPage.vue?vue&type=script&lang=js"
export * from "./ClaimsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__